function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import styles from './obd-meal-card.scss';
import template from './obd-meal-card.html';
import recipeModalTemplate from './recipe-modal.html';

export var ObdMealCardComponent = {
  template: template,
  styles: styles,
  bindings: {
    textTitle: '@',
    slides: '<',
    skipRecipes: '&',
    doneRecipes: '&' },

  controller: /*#__PURE__*/function () {ObdMealCardComponentController.$inject = ["$scope", "$timeout", "ModalsService"];
    function ObdMealCardComponentController($scope, $timeout, ModalsService) {
      "ngInject";_classCallCheck(this, ObdMealCardComponentController);
      console.log(this);
      this.swiperOptions = {
        centeredSlides: false,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        freeMode: true,
        spaceBetween: 1,
        nested: true };

      this.liked = false;
      this.currentSlide = 0;
      this.likedRecipes = [];
      this.$scope = $scope;
      this.$timeout = $timeout;
      this.ModalsService = ModalsService;
    }_createClass(ObdMealCardComponentController, [{ key: "$onInit", value: function $onInit()

      {
      } }, { key: "onSlideChanged", value: function onSlideChanged(

      index) {
        this.currentSlide = index;
        this.recipe = this.slides[this.currentSlide];
        this.liked = this.recipe.liked;
      } }, { key: "handlerChangeSlide", value: function handlerChangeSlide(

      slide) {
        slide === 'next' && this.currentSlide !== this.slides.length - 1 ?
        this.currentSlide = this.currentSlide + 1 :
        slide === 'prev' && this.currentSlide !== 0 ?
        this.currentSlide = this.currentSlide - 1 :
        false;
        this.recipe = this.slides[this.currentSlide];
        this.liked = this.recipe.liked;
      } }, { key: "handlerLiked", value: function handlerLiked()

      {var _this = this;
        if (this.likedRecipes.length < 3 || this.recipe.liked) {
          this.recipe = this.slides[this.currentSlide];
          this.recipe.liked = !this.recipe.liked;
          if (this.recipe.liked) {
            this.likedRecipes.push(this.recipe.id);
            if (this.likedRecipes.length == 3) {
              this.doneRecipes();
              return;
            }
          } else
          {
            var index = this.likedRecipes.indexOf(this.recipe.id);
            if (index !== -1) this.likedRecipes.splice(index, 1);
          }
          this.$timeout(function () {
            _this.handlerChangeSlide('next');
          }, 600);
        }
      } }, { key: "handlerShowRecipeModal", value: function handlerShowRecipeModal()

      {
        this.recipe = this.slides[this.currentSlide];
        this.ModalsService.custom({
          $scope: this.$scope,
          template: recipeModalTemplate });

      } }]);return ObdMealCardComponentController;}() };